import BlogTwentyTwoContainer from "./container/BlogTwentyTwoContainer";
export default BlogTwentyTwoContainer;
